import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-printer-detail',
  templateUrl: './printer-detail.component.html',
  styleUrls: ['./printer-detail.component.scss'],
  standalone: false,
})
export class PrinterDetailComponent {
  @Input() location;
  @Input() customerName;
  constructor(private modalCtrl: ModalController) {}

  dismiss() {
    this.modalCtrl.dismiss();
  }

  select() {
    this.modalCtrl.dismiss(this.location);
  }
}
